<div class="account-pages my-5">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-4">
        <div class="text-center">
          <div class="auth-logo mb-3">
            <a [routerLink]="'/'" class="logo logo-dark">
              <span class="logo-lg">
                <img
                  src="../../../assets/images/logos/logo-dark.svg"
                  alt="{{ 'layout.common.logo.direct_cayc' | translate }}"
                  height="32"
                />
              </span>
            </a>

            <a [routerLink]="'/'" class="logo logo-light">
              <span class="logo-lg">
                <img
                  src="../../../assets/images/logos/logo-light.svg"
                  alt="{{ 'layout.common.logo.direct_cayc' | translate }}"
                  height="32"
                />
              </span>
            </a>
          </div>
        </div>
        <div class="card">
          <div class="card-body p-4">
            <router-outlet></router-outlet>
          </div>
        </div>

        <div class="text-center">
          <p class="footer-copyright">
            <small
              >&copy; {{ today | date : "yyyy" }}
              {{ "public.layout.footer.description" | translate }}<br /><a
                href="https://gesthispania.com"
                target="_blank"
                ><img
                  src="https://archivosgeos.s3.eu-west-1.amazonaws.com/Logo_positivo_horizontal.png"
                  alt="{{ 'layout.common.logo.gesthispania' | translate }}"
                  title="Gestorías Asociadas Gesthispania S.L."
                  width="130" /></a
            ></small>
          </p>
        </div>

        <ng-content select="[footerLink]"></ng-content>
      </div>
    </div>
  </div>
</div>
